import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { EasyEntryScreen } from "../screens/EasyEntryScreen";
import { easyEntrySearch } from "../screens/reportSearch";

export const Route = createFileRoute("/prototype/c/$companyId/banking/easy-entries/new")({
  validateSearch: (search) => easyEntrySearch.parse(search),
  component: EasyEntry,
});

function EasyEntry() {
  const { companyId } = Route.useParams();
  const { type } = Route.useSearch();
  return (
    <EasyEntryScreen companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY} type={type} />
  );
}
